import DashboardIntegrationProvider from './DashboardIntegrationProvider'

export default DashboardIntegrationProvider
